import { useEffect, useMemo, useState,useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Card, Typography, Tooltip, IconButton, Badge, Popover } from "@mui/material";
import TopSection from "../../LT/TopSection";
import ButtonComponent from "../../../components/common/button/Button";
import DataTable from "../../../components/common/datatable/DataTable";
import { MultiDropdown } from "../../../components/common/MultiDropdown";
import { fetchData } from "../../../redux/actions/apiSlice";
import { fetchAfcAnalysis } from "../../../redux/actions/afcAnalysisSlice";
import { fetchSupplierSummary } from "../../../redux/actions/supplierSummarySlice";
import { getSupplierSummary, getAfcAnalysis } from "../../../common/endpoints";
import Modal from "../../../components/common/modal/Modal";
import ManagePrsTable from "./ManagePrsTable";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GraphComponent from "../../../components/common/graph/GraphComponent";
import AFCAnalysisTable from "./AFCAnalysisTable";  
import "./AFCAnalysisTable.css";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { SupplierTableHeaders } from "./SupplierDetails/SupplierTableHeaders";
import { formatDateToDDMMYYYY } from "../../../utils/dateUtils";

const DEEP_DIVE_COLUMN_OPTIONS = [
  { title: "Week of delivery date(GR)", value: "Week of GR Date", name: "Week of GR Date" },
  
  { title: "Supplier Forecast Published", value: "totalSupplierForecastOriginal", name: "totalSupplierForecastOriginal" },
  { title: "Current SAP Forecast", value: "totalSupplierForecastCurrent", name: "totalSupplierForecastCurrent" },
  { title: "Total Supplier Confirmation", value: "totalSupplierConfirmation", name: "totalSupplierConfirmation" },
  { title: "Simulate Total Supplier Confirmation", value: "simulateTotalSupplierConfirmation", name: "simulateTotalSupplierConfirmation" },
  { title: "Total Firm Supply", value: "totalFirmSupply", name: "totalFirmSupply" },
  { title: "PO by GR Date", value: "poByGrDate", name: "poByGrDate" },
  { title: "PO Past Due", value: "poPastDue", name: "poPastDue" },
  { title: "Safety Stock", value: "safetyStock", name: "safetyStock" },
  { title: "Supplier Confirmation(Cumulative)", value: "supplierConfirmationCumulative", name: "supplierConfirmationCumulative" },
  { title: "Cumulative Supplier Forecast Published", value: "cumulativeForecastOriginal", name: "cumulativeForecastOriginal" },
  { title: "Cumulative Current SAP Forecast", value: "cumulativeForecastCurrent", name: "cumulativeForecastCurrent" },
  { title: "Delta (Cumulative) Supplier Forecast Published", value: "deltaCumulativeOriginal", name: "deltaCumulativeOriginal" },
  { title: "Delta (Cumulative) Current SAP Forecast", value: "deltaCumulativeCurrent", name: "deltaCumulativeCurrent" },
  { title: "Proj. Stock Based On Confirmation", value: "projStockBasedOnConfirmation", name: "projStockBasedOnConfirmation" },
  { title: "SS Breach?", value: "ssBreach", name: "ssBreach" },
  { title: "Stockout?", value: "stockout", name: "stockout" },
];

const DEFAULT_DEEP_DIVE_VISIBLE_FIELDS = [
  "Week of GR Date",
  "creationDate",
  "totalSupplierForecastOriginal",
  "totalSupplierForecastCurrent",
  "totalSupplierConfirmation",
  "simulateTotalSupplierConfirmation",
  "projStockBasedOnConfirmation",
  "ssBreach",
  "stockout",
];

const getDefaultDeepDiveHiddenColumns = () =>
  DEEP_DIVE_COLUMN_OPTIONS.map((opt) => opt.value).filter(
    (value) => !DEFAULT_DEEP_DIVE_VISIBLE_FIELDS.includes(value)
  );
const MaterialDetails = () => {
 
  const { materialId, plantId ,supplierId, supplierName} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const data = useSelector((state) => state.api?.data);
  const loading = useSelector((state) => state.api?.loading);
  const error = useSelector((state) => state.api?.error);

  const afcAnalysisData = useSelector((state) => state.afcAnalysis?.data);
  const afcAnalysisLoading = useSelector((state) => state.afcAnalysis?.loading);
  const afcAnalysisError = useSelector((state) => state.afcAnalysis?.error);

  const supplierSummaryData = useSelector((state) => state.supplierSummary?.data);
  const supplierSummaryLoading = useSelector((state) => state.supplierSummary?.loading);
  const supplierSummaryError = useSelector((state) => state.supplierSummary?.error);
  const [showManageModal, setShowManageModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
    const [originalTableRows, setOriginalTableRows] = useState([]);
    const [showDeepDiveReset, setShowDeepDiveReset] = useState(false);
  const [deepDiveColumnAnchor, setDeepDiveColumnAnchor] = useState(null);
  const [deepDiveHiddenColumns, setDeepDiveHiddenColumns] = useState(
    getDefaultDeepDiveHiddenColumns
  );
  const [deepDivePendingHiddenColumns, setDeepDivePendingHiddenColumns] = useState([]);
  const description =
    state?.description ||
    data?.meta?.description || // if your API nests metadata
    data?.description ||       // or flat shape
    "";
  const materialGroup =
    state?.materialGroupDesc ??
    state?.materialGroup ??
    data?.materialGroupDesc ??
    data?.materialGroup ??
    "";
  const purchaseGroup =
    state?.purchasingGroup ??
    state?.purchaseGroup ??
    data?.purchasingGroup ??
    data?.purchaseGroup ??
    "";
  const mrpController =
    state?.mrpController ??
    state?.mrpCtrl ??
    data?.mrpController ??
    data?.mrpCtrl ??
    "";
  const displayOrDash = (value) =>
    value === undefined || value === null || value === "" ? "—" : value;
    
    const [selectedPeriodForecast, setSelectedPeriodForecast] = useState("4W");
  const [selectedPeriodDelta, setSelectedPeriodDelta] = useState("4W");
  const [selectedPeriodStock, setSelectedPeriodStock] = useState("4W");   
const PERIOD_TO_WEEKS = {
  "4W": 4,
  "8W": 8,
  "13W": 13,
  "26W": 26,
  "All": null,
};
 const [tableRowsState, setTableRowsState] = useState([]);
 const [graphModalOpen, setGraphModalOpen] = useState(false);
  const [activeGraph, setActiveGraph] = useState(null);
 const openGraphModal = (key) => {
    setActiveGraph(key);
    setGraphModalOpen(true);
  };

  const closeGraphModal = () => {
    setGraphModalOpen(false);
  };

 


const handleSupplierAction = (row) => {
  const supplierId = row?.supplierId || row?.supplier;
  const sName = row?.supplierName || "";
  navigate(`/dashboard/material/${materialId}/${plantId}/supplier/${encodeURIComponent(supplierId || '')}${sName ? `/${encodeURIComponent(sName)}` : ""}`, { state: { supplierRow: row,supplierName: sName,supplierRows } });
};
   const [supplierRows, setSupplierRows] = useState([]);

  const handleSaveConfirmation = (row) => {
const today = new Date().toISOString().slice(0, 10).split("-").reverse().join("-");
    setSupplierRows((prev) =>
      prev.map((r) =>
        r.id === row.id
          ? {
              ...r,
              confirmed: "Yes",
              confirmedDate: r.confirmedDate || today,
              considerFullConfirmationSaved: true,
              considerFullConfirmation: "Yes",
              totalSupplierConfirmation: r.totalSupplierForecast,
              variance: 0,
              variancePercent: "0.0%",
            }
          : r
      )
    );
  };

  const handleResetConfirmation = (row) => {
    setSupplierRows((prev) =>
      prev.map((r) =>
        r.id === row.id
          ? {
              ...r,
              confirmed: r.originalConfirmed ?? "No",
              confirmedDate: r.originalConfirmedDate ?? "",
              considerFullConfirmationSaved: false,
              considerFullConfirmation: "No",
              totalSupplierConfirmation:
                r.originalTotalSupplierConfirmation ?? r.totalSupplierConfirmation,
              variance: r.originalVariance ?? r.variance,
              variancePercent: r.originalVariancePercent ?? r.variancePercent,
            }
          : r
      )
    );
  };

  const supplierColumns = SupplierTableHeaders({onRowClick: handleSupplierAction,
  onSave: handleSaveConfirmation,
  onReset: handleResetConfirmation,});
 


  

  useEffect(() => {
    if (!materialId || !plantId) return;
    dispatch(
      fetchSupplierSummary({
        dynamicEndpoint: `${getSupplierSummary}?plant=${encodeURIComponent(plantId)}&materials=${encodeURIComponent(materialId)}`,
      })
   
    );
  }, [dispatch, materialId, plantId]);

  useEffect(() => {
    if (!supplierSummaryData) return;
    const rows = Array.isArray(supplierSummaryData?.suppliers) ? supplierSummaryData.suppliers : [];
    setSupplierRows(
      rows.map((item, index) => {
        const variancePercent =
          item?.supplierVariancePercent === null || item?.supplierVariancePercent === undefined
            ? null
            : `${Number(item.supplierVariancePercent)}%`;

        return {
          id: `${item?.supplier ?? "supplier"}-${index}`,
          supplierId: item?.supplier ?? "",
          supplier: item?.supplier ?? "",
          supplierName: item?.supplierName || "",
          totalSupplierForecast: Number(item?.totalSupplierForecast ?? 0),
          totalSupplierConfirmation: Number(item?.totalSupplierConfirmation ?? 0),
          variance: Number(item?.supplierVariance ?? 0),
          variancePercent,
          confirmed: item?.confirmedStatus ?? "No",
          confirmedDate: item?.confirmedDate ?? "",
          considerFullConfirmation: "No",
          considerFullConfirmationSaved: false,
          originalTotalSupplierConfirmation: Number(item?.totalSupplierConfirmation ?? 0),
          originalVariance: Number(item?.supplierVariance ?? 0),
          originalVariancePercent: variancePercent,
          originalConfirmed: item?.confirmedStatus ?? "No",
          originalConfirmedDate: item?.confirmedDate ?? "",
        };
      })
    );
  }, [supplierSummaryData]);


  // Map afcAnalysisData to table rows for deep dive

  // Helper to show N/A for null/undefined so Set Filter does not show Blanks
  const dashIfNull = (val) => (val === null || val === undefined ? 'N/A' : val);

  const tableRows = useMemo(() => {
    if (afcAnalysisData && Array.isArray(afcAnalysisData)) {
      return afcAnalysisData.map((item, idx) => ({
        id: idx,
        // Accept either `grdate` or `grDate` from API (some endpoints differ in casing)
        weekStartDate: dashIfNull(item.grdate ?? item.grDate),
        weekEndDate: 'N/A', // Not provided by API
        "Week of GR Date": dashIfNull(item.grdate ?? item.grDate),
        publishedDate: dashIfNull(item.publishedDate ?? item.publicationDate ?? item.PUBLICATION_DATE ?? item.publication_date),
        currentForecastDate: dashIfNull(item.currentForecastDate ?? item.CURRENT_FORECAST_DATE ?? item.current_forecast_date),
        creationDate:
          dashIfNull(
            item.creationDate ??
              item.CREATION_DATE ??
              item.creation_date ??
              item.publicationDate ??
              item.PUBLICATION_DATE ??
              item.publication_date
          ),
        totalSupplierForecastOriginal: dashIfNull(item.originalForecast),
        totalSupplierForecastCurrent: dashIfNull(item.currentForecast),
        totalSupplierConfirmation: dashIfNull(item.supplierConfirmation),
        simulateTotalSupplierConfirmation: dashIfNull(item.supplierConfirmation), // default simulation to actual
        supplierQuantityConfirmation: dashIfNull(item.supplierConfirmation),
        cumulativeForecastOriginal: dashIfNull(item.cumulativeForecastOriginal),
        cumulativeForecastCurrent: dashIfNull(item.cumulativeForecastCurrent),
        supplierConfirmationCumulative: dashIfNull(item.cumulativeSupplierConfirmation),
        deltaCumulativeOriginal: dashIfNull(item.deltaCumulativeOriginal),
        deltaCumulativeCurrent: dashIfNull(item.deltaCumulativeCurrent),
        safetyStock: item.safetyStock ?? null,
        projStockBasedOnConfirmation: dashIfNull(item.projectedSoh),
        ssBreach: dashIfNull(item.safetyBreach),
        stockout: dashIfNull(item.isStockout),
        stoByGrDate: dashIfNull(item.stobygrdate),
        // Accept either casing for PO by GR date field as well
        poByGrDate: dashIfNull(item.poByGrDate ?? item.pobygrdate),
        stoPastDue: dashIfNull(item.stobygrPastdue),
        poPastDue: dashIfNull(item.poByGrPastdue),
        otherReceipts: dashIfNull(item.otherReceipts),
      }));
    }
    // fallback to dummy if no API data
    return [];
  }, [afcAnalysisData]);

  // Fetch AFC Analysis data for deep dive
  useEffect(() => {
    if (!materialId || !plantId) return;
    dispatch(
      fetchAfcAnalysis({
        dynamicEndpoint: `${getAfcAnalysis}?plant=${encodeURIComponent(plantId)}&material=${encodeURIComponent(materialId)}`
      })
    );
  }, [dispatch, materialId, plantId]);

useEffect(() => {
    setTableRowsState((prevRows) => {
      if (!showDeepDiveReset) return tableRows;

      const prevById = new Map((prevRows || []).map((row) => [row?.id, row]));

      // Preserve user-simulated fields when fresh API rows come in.
      return (tableRows || []).map((row) => {
        const previous = prevById.get(row?.id);
        if (!previous) return row;

        return {
          ...row,
          simulateTotalSupplierConfirmation:
            previous.simulateTotalSupplierConfirmation ?? row.simulateTotalSupplierConfirmation,
          supplierConfirmationCumulative:
            previous.supplierConfirmationCumulative ?? row.supplierConfirmationCumulative,
          deltaCumulativeOriginal:
            previous.deltaCumulativeOriginal ?? row.deltaCumulativeOriginal,
          deltaCumulativeCurrent:
            previous.deltaCumulativeCurrent ?? row.deltaCumulativeCurrent,
          projStockBasedOnConfirmation:
            previous.projStockBasedOnConfirmation ?? row.projStockBasedOnConfirmation,
          ssBreach: previous.ssBreach ?? row.ssBreach,
          stockout: previous.stockout ?? row.stockout,
        };
      });
    });

    setOriginalTableRows(tableRows);
  }, [tableRows, showDeepDiveReset]);

  const handleDeepDiveRowsUpdate = useCallback((updatedRows) => {
    setTableRowsState(updatedRows);
    setShowDeepDiveReset(true);
  }, []);

  const handleResetDeepDive = useCallback(() => {
    setTableRowsState(originalTableRows);
    setShowDeepDiveReset(false);
  }, [originalTableRows]);

  const openDeepDiveColumnSelector = (event) => {
    const selected = deepDiveHiddenColumns
      .map((field) => DEEP_DIVE_COLUMN_OPTIONS.find((option) => option.value === field))
      .filter(Boolean);
    setDeepDivePendingHiddenColumns(selected);
    setDeepDiveColumnAnchor(event.currentTarget);
  };

  const closeDeepDiveColumnSelector = () => setDeepDiveColumnAnchor(null);

  const handleDeepDiveHiddenColumnsChange = (_name, items) => {
    const cleanedItems = (items || []).filter((item) => item?.title !== "Select All");
    setDeepDivePendingHiddenColumns(cleanedItems);
  };

  const applyDeepDiveHiddenColumns = () => {
    const hiddenFields = (deepDivePendingHiddenColumns || []).map((item) => item.value);
    setDeepDiveHiddenColumns(hiddenFields);
    setDeepDiveColumnAnchor(null);
  };


  const formatShortDate = (dateStr) => {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    })
    .replace(/ /g, "-");
};

  const getFirstDateValue = (...values) =>
    values.find((value) => value !== undefined && value !== null && value !== "" && value !== "—" && value !== "-") || "—";

  const getFirstDateFromRows = (rows, selectors = []) => {
    const list = Array.isArray(rows) ? rows : [];
    for (const row of list) {
      const candidate = getFirstDateValue(...selectors.map((select) => select?.(row)));
      if (candidate !== "—") return candidate;
    }
    return "—";
  };

  const forecastDateInfo = useMemo(() => {
    const rows = Array.isArray(afcAnalysisData) ? afcAnalysisData : [];

    const publishedRaw = getFirstDateFromRows(rows, [
      (r) => r?.publicationDate,
      (r) => r?.PUBLICATION_DATE,
      (r) => r?.publication_date,
      (r) => r?.publishedDate,
    ]);

    const currentRaw = getFirstDateFromRows(rows, [
      (r) => r?.currentForecastDate,
      (r) => r?.CURRENT_FORECAST_DATE,
      (r) => r?.current_forecast_date,
    ]);

    const confirmationRaw = getFirstDateFromRows(rows, [
      (r) => r?.confirmationDate,
      (r) => r?.CONFIRMATION_DATE,
      (r) => r?.confirmation_date,
      (r) => r?.confirmedDate,
      (r) => r?.CONFIRMED_DATE,
      (r) => r?.confirmed_date,
    ]);

    const extractionRaw = getFirstDateFromRows(rows, [
      (r) => r?.extractionDate,
      (r) => r?.EXTRACTION_DATE,
      (r) => r?.extraction_date,
    ]);

    return {
      published: formatDateToDDMMYYYY(publishedRaw),
      current: formatDateToDDMMYYYY(currentRaw),
      confirmation: formatDateToDDMMYYYY(confirmationRaw),
      extraction: formatDateToDDMMYYYY(extractionRaw),
    };
  }, [afcAnalysisData]);

  const formatWeekLabel = (row) => {
    if (!row) return "—";
    if (row["Week of GR Date"]) return row["Week of GR Date"];
    return formatShortDate(row.weekStartDate);
  };

  // Determine tick rotation based on selected period and whether chart is modal
  const getTickRotation = (period, isModal = false) => {
    const weeks = PERIOD_TO_WEEKS[period];
    if (!weeks) return isModal ? 45 : 35;
    if (weeks <= 4) return 0;
    if (weeks <= 8) return isModal ? 25 : 20;
    if (weeks <= 13) return isModal ? 30 : 25;
    if (weeks <= 26) return isModal ? 45 : 30;
    return isModal ? 45 : 35;
  };
  const infoText = {
    "Uncovered %": "Percent of demand not covered by confirmed supply.",
    "Safety Stock Breach": "Number of weeks breaching the safety threshold.",
  };
  const supplierMetrics = useMemo(() => {
    const rows = Array.isArray(supplierRows) ? supplierRows : [];
    const confirmedRows = rows.filter(
      (row) => String(row?.confirmed || "").toLowerCase() === "yes"
    );

    const totalSupplierForecast = confirmedRows.reduce(
      (sum, row) => sum + Number(row?.totalSupplierForecast || 0),
      0
    );
    const totalSupplierConfirmation = confirmedRows.reduce(
      (sum, row) => sum + Number(row?.totalSupplierConfirmation || 0),
      0
    );
    const variance = confirmedRows.reduce(
      (sum, row) =>
        sum + (Number(row?.totalSupplierConfirmation || 0) - Number(row?.totalSupplierForecast || 0)),
      0
    );
    const variancePct =
      totalSupplierForecast > 0
        ? ((variance / totalSupplierForecast) * 100) || 0
        : 0;

    return {
      totalSupplierForecast,
      totalSupplierConfirmation,
      variance,
      variancePct,
      supplierCount: rows.length,
    };
  }, [supplierRows]);

  const metrics = [
    {
      label: "Total Supplier Forecast",
      value: supplierMetrics.totalSupplierForecast,
      description: "Confirmed Suppliers Only",
    },
    {
      label: "Total Supplier Confirmation",
      value: supplierMetrics.totalSupplierConfirmation,
      description: "Confirmed Suppliers Only",
    },
    {
      label: "Variance(Confirmation - Forecast)",
      value: supplierMetrics.variance,
      description: "Confirmed Suppliers Only",
    },
    {
      label: "Variance %",
      value: supplierMetrics.variancePct === null ? "—" : `${supplierMetrics.variancePct.toFixed(1)}%`,
      description: "Confirmed Suppliers",
    },
    {
      label: "# of Suppliers",
      value: supplierMetrics.supplierCount,
      description: "Confirmed/Pending",
    },
  ];
  const detailRows = useMemo(() => {
    const rows = (tableRows || []).slice(-3);
    return rows.map((r) => ({
      label: formatShortDate(r.weekStartDate),
      demand: r.cumulativeDemand ?? "—",
      supply: r.cumulativeSupply ?? "—",
      variance: r.cumulativeShortage ?? "—",
    }));
  }, [tableRows]);

// Helper to parse ISO-like week dates safely
const parseDateSafe = (s) => {
  if (!s || s === '-' || s === '—') return null;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
};

const filteredChartRows = useMemo(() => {
  const weeks = PERIOD_TO_WEEKS[selectedPeriodForecast];
  if (!weeks) return tableRowsState;
  const sorted = [...tableRowsState].filter(r => parseDateSafe(r.weekStartDate)).sort(
    (a, b) => parseDateSafe(a.weekStartDate) - parseDateSafe(b.weekStartDate)
  );
  const latest = sorted[sorted.length - 1]?.weekStartDate;
  if (!latest) return sorted;
  const latestDate = new Date(latest);
  const cutoff = new Date(latestDate);
  cutoff.setDate(cutoff.getDate() - (weeks - 1) * 7);
  return sorted.filter((r) => new Date(r.weekStartDate) >= cutoff);
}, [tableRowsState, selectedPeriodForecast]);

  // Debug: log filtered counts and date ranges when period changes
  useEffect(() => {
    try {
      const weeks = PERIOD_TO_WEEKS[selectedPeriodForecast];
      const total = (tableRowsState || []).length;
      const filtered = (filteredChartRows || []).length;
      const earliest = filteredChartRows[0]?.weekStartDate || tableRowsState[0]?.weekStartDate;
      const latest = filteredChartRows[filtered - 1]?.weekStartDate || tableRowsState[tableRowsState.length - 1]?.weekStartDate;
    
    } catch (e) {
    }
  }, [selectedPeriodForecast, tableRowsState, filteredChartRows]);

const filteredDeltaRows = useMemo(() => {
  const weeks = PERIOD_TO_WEEKS[selectedPeriodDelta];
  if (!weeks) return tableRowsState;
  const sorted = [...tableRowsState].filter(r => parseDateSafe(r.weekStartDate)).sort(
    (a, b) => parseDateSafe(a.weekStartDate) - parseDateSafe(b.weekStartDate)
  );
  const latest = sorted[sorted.length - 1]?.weekStartDate;
  if (!latest) return sorted;
  const latestDate = new Date(latest);
  const cutoff = new Date(latestDate);
  cutoff.setDate(cutoff.getDate() - (weeks - 1) * 7);
  return sorted.filter((r) => new Date(r.weekStartDate) >= cutoff);
}, [tableRowsState, selectedPeriodDelta]);

  useEffect(() => {
    try {
      const weeks = PERIOD_TO_WEEKS[selectedPeriodDelta];
      const total = (tableRowsState || []).length;
      const filtered = (filteredDeltaRows || []).length;
      const earliest = filteredDeltaRows[0]?.weekStartDate || tableRowsState[0]?.weekStartDate;
      const latest = filteredDeltaRows[filtered - 1]?.weekStartDate || tableRowsState[tableRowsState.length - 1]?.weekStartDate;
      
    } catch (e) {
    }
  }, [selectedPeriodDelta, tableRowsState, filteredDeltaRows]);


const filteredStockRows = useMemo(() => {
  const weeks = PERIOD_TO_WEEKS[selectedPeriodStock];
  if (!weeks) return tableRowsState;
  const sorted = [...tableRowsState].filter(r => parseDateSafe(r.weekStartDate)).sort(
    (a, b) => parseDateSafe(a.weekStartDate) - parseDateSafe(b.weekStartDate)
  );
  const latest = sorted[sorted.length - 1]?.weekStartDate;
  if (!latest) return sorted;
  const latestDate = new Date(latest);
  const cutoff = new Date(latestDate);
  cutoff.setDate(cutoff.getDate() - (weeks - 1) * 7);
  return sorted.filter((r) => new Date(r.weekStartDate) >= cutoff);
}, [tableRowsState, selectedPeriodStock]);

  useEffect(() => {
    try {
      const weeks = PERIOD_TO_WEEKS[selectedPeriodStock];
      const total = (tableRowsState || []).length;
      const filtered = (filteredStockRows || []).length;
      const earliest = filteredStockRows[0]?.weekStartDate || tableRowsState[0]?.weekStartDate;
      const latest = filteredStockRows[filtered - 1]?.weekStartDate || tableRowsState[tableRowsState.length - 1]?.weekStartDate;
      
    } catch (e) {
    }
  }, [selectedPeriodStock, tableRowsState, filteredStockRows]);

  // Debug: inspect tableRowsState for parsing issues
  useEffect(() => {
    try {
      const total = (tableRowsState || []).length;
      const parsedInfo = (tableRowsState || []).map((r) => ({ raw: r?.weekStartDate, ok: !!parseDateSafe(r?.weekStartDate) }));
      const parsedCount = parsedInfo.filter((p) => p.ok).length;
      const invalid = parsedInfo.filter((p) => !p.ok).map((p) => p.raw);
      const parsedDates = parsedInfo.filter((p) => p.ok).map((p) => p.raw);
      
    } catch (e) {
    }
  }, [tableRowsState]);





  const handleBack = () => navigate("/dashboard");
  const openManageModal = () => setShowManageModal(true);
  const closeManageModal = () => setShowManageModal(false);
  const alCommandCenterBaseUrl =
    (process.env.REACT_APP_CC_BASE_URL || "").replace(/\/+$/, ""); ;
  const alternateSourcingUrl = `${alCommandCenterBaseUrl}/core/inventory/node/inventory/inventory-detail/${encodeURIComponent(
    materialId || ""
  )}/${encodeURIComponent(plantId || "")}`;



const chartData = useMemo(() => {
  const labels = filteredChartRows.map((r) => formatWeekLabel(r));

  return {
    labels,
    datasets: [
      {
        label: "Forecast",
        data: filteredChartRows.map(
          (r) => r.originalForecast ?? r.totalSupplierForecastOriginal ?? 0
        ),
        backgroundColor: "#1d4ed8",
        barThickness: 4,
      },
      {
        label: "Confirmation",
        data: filteredChartRows.map(
          (r) => r.supplierQuantityConfirmation ?? r.totalSupplierConfirmation ?? 0
        ),
        backgroundColor: "#22c55e",
        barThickness: 4,
      },
      {
          label: "Supply",
          data: filteredChartRows.map(
            (r) => r.cumulativeSupply ?? r.totalFirmSupply ?? 0
          ),
          backgroundColor: "#f59e0b",
          barThickness: 4,
        },
    ],
  };
}, [filteredChartRows]);




  // Helper to get min/max for y-axis from datasets
  const getYDomain = (datasets) => {
    let all = [];
    datasets.forEach(ds => {
      if (Array.isArray(ds.data)) {
        all = all.concat(ds.data.filter(v => typeof v === 'number' && !isNaN(v)));
      }
    });
    if (!all.length) return { min: 0, max: 1 };
    let min = Math.min(...all);
    let max = Math.max(...all);
    // Add some padding
    if (min === max) {
      min = min - 1;
      max = max + 1;
    } else {
      min = Math.floor(min - Math.abs(max - min) * 0.1);
      max = Math.ceil(max + Math.abs(max - min) * 0.1);
    }
    return { min, max };
  };

  // Forecast-specific chart options (isolated from delta/stock)
  const forecastChartOptions = useMemo(() => {
    const { min, max } = getYDomain(chartData.datasets);
    const rotation = getTickRotation(selectedPeriodForecast, false);
    return {
      responsive: true,
      plugins: { legend: { position: "bottom" } },
      maintainAspectRatio: false,
      layout: { padding: { left: 4, right: 6, top: 0, bottom: 0 } },
      scales: {
        x: {
          grid: { display: false },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 26,
            maxRotation: rotation,
            minRotation: rotation,
            padding: 4,
            font: { size: 9 },
            callback: function (value) {
              const label = this.getLabelForValue(value) || "";
              return label.length > 15 ? `${label.slice(0, 15)}…` : label;
            },
          },
        },
        y: {
          beginAtZero: true,
          min,
          max,
          ticks: { padding: 4, font: { size: 9 } },
        },
      },
      animation: { duration: 200, easing: "easeOutQuart" },
      transitions: {
        active: { animation: { duration: 200 } },
        resize: { animation: { duration: 0 } },
      },
    };
  }, [chartData]);


  const deltaChartData = useMemo(() => {
  const labels = filteredDeltaRows.map((r) => formatWeekLabel(r));

  return {
    labels,
    datasets: [
      {
        label: "Delta (Cumulative) Original",
        data: filteredDeltaRows.map((r) => r.deltaCumulativeOriginal ?? 0),
          type: "line",
       
        borderColor: "#f97316",
    
  tension: 0,
  fill: false,
  pointRadius: 1,
  pointHoverRadius: 3,
  borderWidth: 0.75,
      },
      {
        label: "Delta (Cumulative) Current",
        data: filteredDeltaRows.map((r) => r.deltaCumulativeCurrent ?? 0),
       type: "line",
       
         borderColor: "#dc2626",
        
  tension: 0,
  fill: false,
  pointRadius: 1,
  pointHoverRadius: 3,
  borderWidth: 0.75,
      },
    ],
  };
}, [filteredDeltaRows]);

  // Delta-specific chart options (isolated)
  const deltaChartOptions = useMemo(() => {
    const { min, max } = getYDomain(deltaChartData.datasets);
    const rotation = getTickRotation(selectedPeriodDelta, false);
    const xScale = forecastChartOptions.scales?.x || {};
    const ticks = { ...(xScale.ticks || {}), maxRotation: rotation, minRotation: rotation };
    const scales = { ...forecastChartOptions.scales, x: { ...xScale, ticks }, y: { ...forecastChartOptions.scales?.y, min, max } };
    return { ...forecastChartOptions, scales };
  }, [forecastChartOptions, deltaChartData]);


const stockChartData = useMemo(() => {
  const labels = filteredStockRows.map((r) => formatWeekLabel(r));
  return {
    labels,
    datasets: [
      {
        label: "Proj. Stock Based On Confirmation",
        data: filteredStockRows.map((r) => r.projStockBasedOnConfirmation ?? 0),
        type: "line", 
       
        borderColor: "#2563eb",
        
  tension: 0,
  fill: false,
  pointRadius: 1,
  pointHoverRadius: 3,
  borderWidth: 0.75,
      },
      {
        label: "Safety Stock",
        data: filteredStockRows.map(
          (r) => r.safetyStock ?? Math.round((r.safetyStock ?? 0) * 0.7)
        ),
        
        
       borderColor: "#f97316",
        type: "line" ,
  tension: 0,
  fill: false,
  pointRadius: 1,
  pointHoverRadius: 3,
  borderWidth: 0.75,
       
      },
    ],
  };
}, [filteredStockRows]);



  


  const stockChartOptions = useMemo(() => {
    const { min, max } = getYDomain(stockChartData.datasets);
    const rotation = getTickRotation(selectedPeriodStock, false);
    const xScale = forecastChartOptions.scales?.x || {};
    const ticks = { ...(xScale.ticks || {}), maxRotation: rotation, minRotation: rotation };
    const scales = { ...forecastChartOptions.scales, x: { ...xScale, ticks }, y: { ...forecastChartOptions.scales?.y, min, max } };
    return { ...forecastChartOptions, scales };
  }, [forecastChartOptions, stockChartData]);

  const modalChartOptions = useMemo(() => {
    // Base selection per active graph
    const base =
      activeGraph === "delta"
        ? deltaChartOptions
        : activeGraph === "stock"
        ? stockChartOptions
        : forecastChartOptions;
    if (!base) return forecastChartOptions;

    // Use the active graph's selected period to compute a modal tilt
    const period = activeGraph === "delta" ? selectedPeriodDelta : activeGraph === "stock" ? selectedPeriodStock : selectedPeriodForecast;
    const rotation = getTickRotation(period, true);

    const xScale = base.scales?.x || {};
    const ticks = { ...(xScale.ticks || {}), maxRotation: rotation, minRotation: rotation };
    const scales = { ...base.scales, x: { ...xScale, ticks } };
    return { ...base, maintainAspectRatio: false, scales };
  }, [activeGraph, forecastChartOptions, deltaChartOptions, stockChartOptions, selectedPeriodForecast, selectedPeriodDelta, selectedPeriodStock]);

// Debug: log chart label counts to confirm what's rendered
useEffect(() => {
  try {
  } catch (e) {
  }
}, [chartData, deltaChartData, stockChartData, selectedPeriodForecast, selectedPeriodDelta, selectedPeriodStock]);

  const graphConfig = useMemo(
    () => ({
      forecast: {
        title: "Forecast vs Confirmation",
        data: chartData,
        period: selectedPeriodForecast,
        onPeriodChange: setSelectedPeriodForecast,
      },
      delta: {
        title: "Delta (Cumulative) Trend - Current & Original",
        data: deltaChartData,
        period: selectedPeriodDelta,
        onPeriodChange: setSelectedPeriodDelta,
      },
      stock: {
        title: "Available Stock vs Safety Stock",
        data: stockChartData,
        period: selectedPeriodStock,
        onPeriodChange: setSelectedPeriodStock,
      },
    }),
    [
      chartData,
      deltaChartData,
      stockChartData,
      selectedPeriodForecast,
      selectedPeriodDelta,
      selectedPeriodStock,
    ]
  );

    const modalGraphData = useMemo(() => {
    if (!activeGraph) return null;
    const base = graphConfig[activeGraph]?.data;
    if (!base) return null;

      if (activeGraph === "forecast") {
      return {
        ...base,
        datasets: base.datasets.map((ds) => ({
          ...ds,
          barThickness: 10,
          maxBarThickness: 16,
        })),
      };
    }

    if (activeGraph === "delta" || activeGraph === "stock") {
      return {
        ...base,
        datasets: base.datasets.map((ds) => ({
          ...ds,
          borderWidth: 1,
      pointRadius: 1,
      pointHoverRadius: 3,
      tension: 0,
        })),
      };
    }

    return base;
  }, [activeGraph, graphConfig]);





  return (
    <Box sx={{ width: "100%" }}>
      <TopSection
        labelList={[
         
          { title: "Dashboard", path: "/dashboard" },
          { title: `${materialId}` },
        ]}
        hideHeader={true}
        titlePadding="0"
      />
{/*}
      <Card
        sx={{
          width: "80%",
          borderRadius: 2,
          margin: "2px auto",
          marginBottom: 2,
          padding: 2,
          minHeight: 96,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",

        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, color: "#1976d2" }}>
            {plantId} -{state?.supplier}.{state?.unit}
          </Typography>
          <Typography variant="h6">{materialId} - {description}</Typography>
        </Box>

        <Box sx={{ display: "flex", gap: 1 }}>
          <ButtonComponent
            label="Manage PRS"
            type="primary"
            bgColor="#111010ff"
            color="white"
            onClick={openManageModal}
          />
          <ButtonComponent
            label="Push To IBP"
            type="primary"
            bgColor="#f53c00"
            color="white"
            onClick={handleBack}
          />
          <ButtonComponent
            label="Alternate Sourcing"
            type="primary"
            bgColor="#ffffff"
            color="black"
            onClick={handleBack}
          />
        </Box>
      </Card>
*/}
      <Card
  sx={{
    width: "96%",
    margin: "8px auto",
    borderRadius: 2,
    padding: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
  }}
>
  {/* LEFT SECTION */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
    {/* Material Info */}
    <Box>
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          color: "#64748b",
          letterSpacing: 1,
        }}
      >
        MATERIAL DRILLDOWN 
      </Typography>

      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mt: 0.5 }}
      >
        {materialId}
      </Typography>

      <Typography
        variant="body2"
        sx={{ color: "#64748b" }}
      >
        {description}
      </Typography>
    </Box>

    {/* Divider */}
    <Box sx={{ width: "1px", height: 50, backgroundColor: "#e5e7eb" }} />

    {/* Plant */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        PLANT CODE
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {plantId}
      </Typography>
    </Box>

    {/* Material Group */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        MATERIAL GROUP DESCRIPTION
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {displayOrDash(materialGroup)}
      </Typography>
    </Box>

    {/* Purchase Group */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        PURCHASE GROUP
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {displayOrDash(purchaseGroup)}
      </Typography>
    </Box>

    {/* MRP Controller */}
    <Box>
      <Typography variant="caption" sx={{ color: "#64748b" }}>
        MRP CONTROLLER
      </Typography>
      <Typography sx={{ fontWeight: 600 }}>
        {displayOrDash(mrpController)}
      </Typography>
    </Box>
  </Box>

  
</Card>

     
  <Box sx={{ margin: "4px auto",padding:0.25}}>
        {loading && <Typography>Loading analytics...</Typography>}
        {error && (
          <Typography color="error">{String(error || "Error loading data")}</Typography>
        )}
        {!loading && !error && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
              gap: 2,
            }}
          >
            {metrics.slice(0, 5).map((m, i) => (
              <Card
                key={i}
                sx={{
                  height: 140,
                  borderRadius: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  position: "relative",
                }}
              >
                {infoText[m.label] && (
                  <Tooltip title={infoText[m.label]} arrow>
                    <IconButton
                      size="small"
                      sx={{ position: "absolute", top: 6, right: 6 }}
                    >
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}

                <Typography
                  variant="subtitle1"
                  color="text.primary"
                  sx={{ textAlign: "center", maxWidth: 180, lineHeight: 1.2, whiteSpace: "normal" }}
                >
                  {m.label}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 600 }}>
                  {m.value}
                </Typography>
                 <Typography variant="subtitle2" color="text.secondary">
                  {m.description}
                </Typography>
              </Card>
            ))}

           
          </Box>
        )}
</Box>
 <Box sx={{ margin: "4px auto", border: "1px solid #e0e0e0", borderRadius: 2, padding: 1 }}>

 <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
    <Typography sx={{ fontWeight: 600, fontSize: 18 }}>
      Supplier Summary
    </Typography>

    <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
      <Typography
        component="a"
        href={alternateSourcingUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          color: "#1976d2",
          textDecoration: "none",
          fontWeight: 500,
          border: "1px solid #1976d2",
          borderRadius: "6px",
          px: 1.5,
          py: 0.5,
          display: "inline-block",
        }}
      >
        Alternate Sourcing(Command Center)
      </Typography>
      <Typography sx={{ marginLeft: 2,px:1.5,py:0.5, border: "1px solid #000", borderRadius:"4px", fontSize: 12, color: "black", fontWeight: 600 }}>
        {supplierRows?.length || 0} Supplier{(supplierRows?.length || 0) !== 1 ? "s" : ""}
      </Typography>
    </Box>
  </Box>

 {/* Supplier table ABOVE cards */}
        <Box sx={{ mb: 2 }}>
          
            <DataTable
              height={200}
              rows={supplierRows}
              columns={supplierColumns}
              rowSelection="none"
              suppressRowClickSelection={true}
              // paginationProp={true}
              // paginationPageSize={10}
              defaultColDef={{ flex: 1, minWidth: 120, resizable: true }}
            />
        </Box>
</Box>


        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr", lg: "1fr 1fr 1fr" },
            gap: 2,
            mt: 2,
            width: "100%",
          }}
        >
   
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              p: 2,
              minWidth: 0,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              height: { xs: 320, md: 340, lg: 360 },
            }}
          >
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
                  <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>
    Forecast vs Confirmation
  </Typography>
   <IconButton size="small" onClick={() => openGraphModal("forecast")}>
              <OpenInFullIcon fontSize="small" />
            </IconButton>
</Box>
                   <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, flexWrap: "wrap" }}>
  
  <Typography sx={{ fontWeight: 400,fontSize: 14 }}>PERIOD:</Typography>

  {["4W", "8W", "13W", "26W", "All"].map((p) => (
    <ButtonComponent
      key={p}
      label={p}
      type="primary"
      size="small"
      height="22px"
      maxWidth="44px"
      bgColor={selectedPeriodForecast === p ? "#2563eb" : "#f1f5f9"}
      color={selectedPeriodForecast === p ? "white" : "black"}
      styles={{ minWidth: 32, width: "auto", padding: "0 4px", fontSize: "0.7rem" }}
      onClick={() => setSelectedPeriodForecast(p)}
    />
  ))}
  <Tooltip
    title={
      <span>
        Forecast Published Date: {forecastDateInfo.published}<br />
        Current SAP Forecast Date: {forecastDateInfo.current}<br />
        Extraction Date: {forecastDateInfo.extraction}<br />
        
      </span>
    }
    arrow
  >
    <IconButton size="small" aria-label="Info for forecast period">
      <InfoOutlinedIcon fontSize="small" />
    </IconButton>
  </Tooltip>
</Box>
            <Box sx={{ flex: 1, minHeight: 0 }}>
              <GraphComponent data={chartData} options={forecastChartOptions} />
            </Box>
          </Box>
           <Box
             sx={{
               border: "1px solid #e0e0e0",
               borderRadius: 2,
               p: 2,
               minWidth: 0,
               overflow: "hidden",
               display: "flex",
               flexDirection: "column",
               height: { xs: 320, md: 340, lg: 360 },
             }}
           >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
           
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: 16,
                mb: 1,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
              }}
            >
              Delta (Cumulative) - Current & Original
            </Typography>
            <IconButton size="small" onClick={() => openGraphModal("delta")}>
              <OpenInFullIcon fontSize="small" />
            </IconButton>
</Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, flexWrap: "wrap" }}>
  
  <Typography sx={{ fontWeight: 400,fontSize: 14 }}>PERIOD:</Typography>

  {["4W", "8W", "13W", "26W", "All"].map((p) => (
    <ButtonComponent
      key={p}
      label={p}
      type="primary"
      size="small"
      height="22px"
      maxWidth="44px"
      bgColor={selectedPeriodDelta === p ? "#2563eb" : "#f1f5f9"}
      color={selectedPeriodDelta === p ? "white" : "black"}
      styles={{ minWidth: 32, width: "auto", padding: "0 4px", fontSize: "0.7rem" }}
      onClick={() => setSelectedPeriodDelta(p)}
    />
  ))}
</Box>
            <Box sx={{ flex: 1, minHeight: 0 }}>
              <GraphComponent data={deltaChartData} options={deltaChartOptions} />
            </Box>
          </Box>

{/* Available Stock vs Safety Stock */}
  <Box
    sx={{
      border: "1px solid #e0e0e0",
      borderRadius: 2,
      p: 2,
      minWidth: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      height: { xs: 320, md: 340, lg: 360 },
    }}
  >
   <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
    <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>
     Proj. Stock Confirmation vs Safety Stock
    </Typography>
    <IconButton size="small" onClick={() => openGraphModal("stock")}>
              <OpenInFullIcon fontSize="small" />
            </IconButton>
</Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1, flexWrap: "wrap" }}>
      <Typography sx={{ fontWeight: 400, fontSize: 14 }}>PERIOD:</Typography>
      {["4W", "8W", "13W", "26W", "All"].map((p) => (
        <ButtonComponent
          key={p}
          label={p}
          type="primary"
          size="small"
          height="22px"
          maxWidth="44px"
          bgColor={selectedPeriodStock === p ? "#2563eb" : "#f1f5f9"}
          color={selectedPeriodStock === p ? "white" : "black"}
          styles={{ minWidth: 32, width: "auto", padding: "0 4px", fontSize: "0.7rem" }}
          onClick={() => setSelectedPeriodStock(p)}
        />
      ))}
    </Box>

    <Box sx={{ flex: 1, minHeight: 0 }}>
      <GraphComponent data={stockChartData} options={stockChartOptions} />
    </Box>
  </Box>



        </Box>
         <div className="afc-analysis-table-section">
          <div
            className="afc-analysis-table-header"
          >
              <div className="afc-analysis-table-title">52-WEEK DEEP DIVE</div>
            <div className="afc-analysis-table-actions">
              <Badge
                badgeContent={deepDiveHiddenColumns.length}
                color="primary"
                overlap="circular"
                sx={{ mr: 1 }}
              >
                <IconButton
                  size="small"
                  onClick={openDeepDiveColumnSelector}
                  style={{
                    border: "1px solid #cbd5e1",
                    borderRadius: 6,
                    padding: 4,
                    backgroundColor: "#ffffff",
                  }}
                  aria-label="Hide Columns"
                  aria-haspopup="true"
                  aria-controls={deepDiveColumnAnchor ? "deep-dive-columns-popover" : undefined}
                >
                  <MoreVertIcon fontSize="small" />
                </IconButton>
              </Badge>
              {showDeepDiveReset && (
                <ButtonComponent
                  label="Reset"
                  type="primary"
                  bgColor="#fff3d6"
                  color="black"
                  border="1px solid #000"
                  borderRadius="4px"
                  styles={{ width: "auto", minWidth: "88px" }}
                  onClick={handleResetDeepDive}
                />
              )}
            </div>
          </div>
          <AFCAnalysisTable
            rows={tableRowsState}
            onRowsUpdate={handleDeepDiveRowsUpdate}
            formatWeekLabel={formatWeekLabel}
            hiddenColumns={deepDiveHiddenColumns}
            publishedDateOverride={forecastDateInfo.published}
            currentForecastDateOverride={forecastDateInfo.current}
          />
          <Popover
            id="deep-dive-columns-popover"
            open={Boolean(deepDiveColumnAnchor)}
            anchorEl={deepDiveColumnAnchor}
            onClose={closeDeepDiveColumnSelector}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{ style: { padding: 12, width: 360 } }}
          >
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>
              Hide Columns
            </div>
            <div style={{ display: "grid", gap: 12 }}>
              <MultiDropdown
                name="deepDiveHideColumns"
                options={DEEP_DIVE_COLUMN_OPTIONS}
                selectedItemsData={deepDivePendingHiddenColumns}
                onChangeItems={handleDeepDiveHiddenColumnsChange}
                dropdownWidth="320px"
                minWidth="220px"
              />
              <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                <ButtonComponent
                  label="Cancel"
                  type="secondary"
                  bgColor="#e2e8f0"
                  color="#111827"
                  onClick={closeDeepDiveColumnSelector}
                />
                <ButtonComponent
                  label="Save"
                  type="primary"
                  bgColor="#1976d2"
                  color="#ffffff"
                  onClick={applyDeepDiveHiddenColumns}
                />
              </div>
            </div>
          </Popover>
        </div>
   



     





       <Modal
        open={graphModalOpen}
        handleClose={closeGraphModal}
        onExited={() => setActiveGraph(null)}
        fullWidth
        maxWidth="xl"
        title={graphConfig[activeGraph]?.title || "Graph"}
        content={
           activeGraph ? (
          <Box sx={{ overflow: "hidden" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, flexWrap: "wrap" }}>
              <Typography sx={{ fontWeight: 400, fontSize: 14 }}>PERIOD:</Typography>
              {["4W", "8W", "13W", "26W", "All"].map((p) => (
                <ButtonComponent
                  key={p}
                  label={p}
                  type="primary"
                  size="small"
                  height="20px"
                  maxWidth="44px"
                  bgColor={graphConfig[activeGraph]?.period === p ? "#2563eb" : "#f1f5f9"}
                  color={graphConfig[activeGraph]?.period === p ? "white" : "black"}
                  styles={{ minWidth: 32, width: "auto", padding: "0 4px", fontSize: "0.7rem" }}
                  onClick={() => graphConfig[activeGraph]?.onPeriodChange?.(p)}
                />
              ))}
              {activeGraph === "forecast" && (
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(140px, 1fr))",
                    gap: 1.5,
                    alignItems: "center",
                    marginLeft: "auto",
                  }}
                >
                  <Box>
                    <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                      Forecast Published Date
                    </Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                      {forecastDateInfo.published}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                      Current SAP Forecast Date
                    </Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                      {forecastDateInfo.current}
                    </Typography>
                  </Box>
                   <Box>
                    <Typography sx={{ fontSize: 12, color: "#64748b" }}>
                      Extraction Date
                    </Typography>
                    <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                      {forecastDateInfo.extraction}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>

            <Box sx={{ height: "48vh",overflow: "hidden" }}>
              <GraphComponent
              className="modal-graph"
                data={modalGraphData || graphConfig[activeGraph]?.data}
                options={modalChartOptions}
              />
            </Box>
          </Box>
           ):null
        }
      />



    </Box>
  );
};

export default MaterialDetails;
